import {instance, onErrorFunction, onSuccessFunction} from "../../../config/axios-cnf";

export const apiGetTurnstileTemplate = (subjectId, id=null,callback,error) => {
    if (id == null) {
        instance.get("/api/v2/enigoo/" + subjectId + "/turnstile-template")
            .then((response) => callback(onSuccessFunction(response.data)))
            .catch((err) => error(onErrorFunction(err)));
    } else {
        instance.get("/api/v2/enigoo/" + subjectId + "/turnstile-template/" + id)
            .then((response) => callback(onSuccessFunction(response.data)))
            .catch((err) => error(onErrorFunction(err)));
    }
}

export const apiPostTurnstileTemplate = (subjectId,data,callback,error) => {
    instance.post("/api/v2/enigoo/"+subjectId+"/turnstile-template",data)
        .then((response) => callback(onSuccessFunction(response.data)))
        .catch((err) => error(onErrorFunction(err)));
}
